import type { PropsWithChildren, ReactNode } from 'react';

import { AlertStyled } from './styles/AlertStyled'
import { Flex } from '@ui/elements/Flex'
import { SubText } from '@ui/elements/Text'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IBaseAlertProps {
  /**
   * Unique identifier for analytics tracking of alert interactions.
   */
  analyticsId?: string
  action?: ReactNode
  icon?: ReactNode
}

export const BaseAlert = ({
  analyticsId,
  action,
  children,
  icon,
  ...otherProps
}: PropsWithChildren<IBaseAlertProps>) => {
  const isChildrenString = typeof children === 'string'
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <AlertStyled {...otherProps} {...analyticsProps}>
      <Flex.Row flexWrap='nowrap' alignItems='center'>
        {icon && <Flex.Item flex='0 1'>{icon}</Flex.Item>}
        <Flex.Item flex='1 0'>
          {isChildrenString ? <SubText>{children}</SubText> : <>{children}</>}
        </Flex.Item>
        {action && <Flex.Item ml='auto'>{action}</Flex.Item>}
      </Flex.Row>
    </AlertStyled>
  )
}

BaseAlert.displayName = 'BaseAlert'
